import { LAYOUTS } from '@voltmoney/types';
import { ROUTE } from '../../../routes';
import { ACTION } from './types';
import { goBack, leadToPayment, leadToPaymentPage, learnMoreInterest, needHelp, resetPage } from './actions';
import { WIDGET } from "@voltmoney/schema";
import { api } from "../../../configs/api";
import { getAppHeader } from "../../../configs/config";
import { showNewRepaymentFlowDc } from "../../../configs/utils";
import SharedPropsService from '../../../SharedPropsService';
import { LENDER_ID } from '../../../configs/constants';
export const template = (height, interestResponse, type, bankDetails, isFromTata, lenderId, showNewRepaymentFlow) => ({
    layout: {
        id: ROUTE.REPAYMENT_CHARGES_DETAILS_PAGE,
        type: LAYOUTS.LIST,
        style: {
            isPartnerPlatform: true
        },
        widgets: [
            {
                id: 'interestRepaymentDetails',
                type: WIDGET.INTEREST_REPAYMENT_DETAILS
            }
        ],
    },
    datastore: {
        interestRepaymentDetails: {
            height: height,
            interestRepaymentData: interestResponse,
            type: type,
            bankAccount: '',
            bankDetail: bankDetails,
            isFromTata: isFromTata,
            viewDetailAction: {
                type: showNewRepaymentFlow ? ACTION.LEAD_TO_INTEREST_PAYMENT : ACTION.LEAD_TO_PAYMENT,
                routeId: ROUTE.INTEREST_REPAYMENT_DETAILS,
                payload: {
                    amount: interestResponse.totalAmount
                }
            },
            backAction: {
                type: ACTION.GO_BACK,
                routeId: ROUTE.INTEREST_REPAYMENT_DETAILS,
                payload: {}
            },
            contactSupportAction: {
                type: ACTION.NEED_HELP,
                routeId: ROUTE.INTEREST_REPAYMENT_DETAILS,
                payload: {}
            },
            learnMoreAction: {
                type: ACTION.LEARN_MORE_INTEREST,
                routeId: ROUTE.INTEREST_REPAYMENT_DETAILS,
                payload: {
                    interestReponse: interestResponse,
                    type: type,
                    isFromTata: isFromTata
                }
            },
            lenderId: lenderId
        }
    },
});
export const interestRepaymentDetails = {
    onLoad: async ({ getHeight, network }, { interestResponse, type }) => {
        const user = await SharedPropsService.getUser();
        let isFromTata = user?.linkedCredits[0]?.lendingPartnerId?.toLowerCase() === LENDER_ID.TATA.toLowerCase();
        console.warn("TYPE IN MF", type);
        const lenderId = user?.linkedCredits[0]?.lendingPartnerId;
        const response = await network
            .get(`${api.userProfile}${user.linkedBorrowerAccounts[0].accountId}`, { headers: await getAppHeader() });
        let bankDetails = response?.data?.bankDetails;
        const showNewRepaymentFlow = await showNewRepaymentFlowDc();
        return Promise.resolve(template(getHeight(), interestResponse, type, bankDetails, isFromTata, lenderId, showNewRepaymentFlow));
    },
    actions: {
        [ACTION.GO_BACK]: goBack,
        [ACTION.NEED_HELP]: needHelp,
        [ACTION.LEAD_TO_PAYMENT]: leadToPayment,
        [ACTION.LEARN_MORE_INTEREST]: learnMoreInterest,
        [ACTION.CANCEL_ACTION]: resetPage,
        [ACTION.LEAD_TO_INTEREST_PAYMENT]: leadToPaymentPage,
    },
    clearPrevious: true,
};
